import { Component, OnInit, Input } from '@angular/core';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap';
import { CartService } from 'src/app/services/api/cart.service';
import { OrderService } from 'src/app/services/api/order.service';
import { ProductService } from 'src/app/services/api/product.service';
import { LangService } from 'src/app/services/lang/lang.service';
import { CuttingTypeComponent } from '../product/options/cutting-type/cutting-type.component';

@Component({
  selector: 'app-file-manager-add-to-cart',
  templateUrl: './file-manager-add-to-cart.component.html',
  styleUrls: ['./file-manager-add-to-cart.component.scss']
})
export class FileManagerAddToCartComponent implements OnInit {

	@Input() onClose: any;

	modalRef: BsModalRef;
	file: any;

	maxOrdersOnList:number = 10;

	constructor(
		public orderService: OrderService,
		public productService: ProductService,
		public cartService: CartService,
		public lang: LangService,
		public modalService: BsModalService
	) { }

	ngOnInit(): void {
		if(typeof this.file.orders == 'undefined'){
			this.file.orders = [];
		}
		if(typeof this.file.order_items == 'undefined'){
			this.file.order_items = [];
		}

		this.file.order_ids.forEach((id, key) => {
			/** we have to filter, since we only have show the last order  */
			// if(id == this.file.last_order_id){ 
			// 	this.getOrder(id);
			// }
			if((key + 1) <= this.maxOrdersOnList){
				this.getOrder(id);
			}
		});
	}

	closeModal(data:any = {}){
		this.onClose(data);
	}

	getOrder(id){

		let foundOrder = this.file.orders.find(i => (id == i.entity_id));

		if(!foundOrder){
			this.orderService.getOrder(id).then((order:any) => {
				this.file.orders.push(order);
				foundOrder = this.file.orders.find(i => (id == i.entity_id));
			});
		}
		
		let checkerCount = 0;
		let checker = setInterval(() => {
			if(foundOrder){
				if(this.file.order_item_ids.length > this.file.order_items.length){
					foundOrder.items.forEach(item => {
						if(item.sku.match(/custom-t-shirt/gi)){
							item.sku = 'custom-t-shirt';
							item.parent_item = JSON.parse(JSON.stringify(item));
						}
						if(item.sku.match(/custom-canvas-tote-bag/gi)){
							item.sku = 'custom-canvas-tote-bag';
							item.parent_item = JSON.parse(JSON.stringify(item));
						}

						item.order_increment_id = foundOrder.increment_id;

						if(item.parent_item){
							if(this.orderService.inArray(item.parent_item.item_id, this.file.order_item_ids)){
								let sku = item.sku;
								sku = sku.replace("-" + item.name, "");
		
								this.productService.getProductBySku(sku).then((perProd) => {
									let product: any = perProd;
									item["product"] = product;
	
									let custom_options = item.parent_item.product_option.extension_attributes.custom_options;
	
									let opts = product.options;
	
									item['custom_options'] = [];
									custom_options.forEach((option, key) => {
										opts.forEach(opt => {
											if(parseInt(option.option_id) == opt.option_id){
												if(opt.product_sku == 'custom-t-shirt'){ /** for t-shirt */
													custom_options[key]['title'] = opt.title;
													if(opt.title == 'Color'){
														custom_options[key]['option_value'] = this.getOptionValueTitle(opt, custom_options[key]);
														custom_options[key]['option_value'] = custom_options[key]['option_value'].split('-');
														custom_options[key]['option_value'] = custom_options[key]['option_value'][0];
														item['custom_options'].push(custom_options[key]);
													}
													else if(opt.title == 'Print Location'){
														custom_options[key]['option_value'] = this.getOptionValueTitle(opt, custom_options[key]);
														item['custom_options'].push(custom_options[key]);
													}
													else if(this.productService.inArray(opt.title, ['Size-XS','Size-S','Size-M','Size-L','Size-XL','Size-XXL','Size-XXXL'])){
														if(custom_options[key]['option_value']){
															custom_options[key]['title']  = opt.title.replace('-', ' Qty ');
															item['custom_options'].push(custom_options[key]);
														}
													}
													else if(this.productService.inArray(opt.title, ['Front Size', 'Back Size', 'Left Arm Size', 'Right Arm Size', 'Inside Tag Size'])){
														custom_options[key]['title']  = opt.title;
														item['custom_options'].push(custom_options[key]);
													}
												}
												else if(opt.product_sku == 'custom-canvas-tote-bag'){
													custom_options[key]['title'] = opt.title;

													if(opt.title == 'Sizes' || opt.title == 'Print Location'){
														custom_options[key]['option_value'] = this.getOptionValueTitle(opt, custom_options[key]);
														item['custom_options'].push(custom_options[key]);
													}
													else if(opt.title == 'Front Print Size' || opt.title == 'Back Print Size'){
														item['custom_options'].push(custom_options[key]);
													}
												}
												else {
													if(opt.title == 'custom size'){
														custom_options[key]['title'] = 'size';
														let coSize = custom_options[key]['option_value'].split(' x ');
														if(coSize.length == 2){
															custom_options[key]['option_value'] = coSize[0] + ' cm x ' + coSize[1] + ' cm';
														}
														item['custom_options'].push(custom_options[key]);
													}
													else if(opt.title == 'adhesive'){
														custom_options[key]['title'] = opt.title;
														item['custom_options'].push(custom_options[key]);
													}
													else if(opt.title == 'cutting type'){
														custom_options[key]['title'] = opt.title;
														item['custom_options'].push(custom_options[key]);
														opt.values.forEach(optVal => {
															if(optVal.option_type_id + '' == custom_options[key]['option_value']){
																custom_options[key]['option_value'] = optVal.title;
															}
														});
													}
												}
											}
										});
									});
								});
		
								this.file.order_items.push(item);
							}
						}
					});
				}


				

				clearInterval(checker);
			}

			checkerCount++;
			if(checkerCount >= 40){
				this.orderService.toastService.add('Cannot find order with id ' + id, 'danger');
				clearInterval(checker);
			}
		}, 100);
	}

	getOptionValueTitle(opt:any, co:any){
		let title = [];
		opt.values.forEach(optValue => {
			let coOptionValues = co.option_value.split(',');
			coOptionValues.forEach(coOptionValue => {
				if(coOptionValue + '' ==  optValue.option_type_id + '' ){
					title.push(optValue.title);
				}
			});
		});
		return title.join(', ');
	}

	reAddToCart(item:any) {

		/**
		 * we have to check if the order already have a cutting
		 * type option, this is beause cutting type is just recently been
		 * added. and old order does not have cutting option selected
		 */
		let productHasCuttingType:any = null;
		item.product.options.forEach(option => {
			if(option.title == 'cutting type'){
				productHasCuttingType = option;
			}
		});

		let hasCuttingType:boolean = false;
		if(productHasCuttingType){
			item.custom_options.forEach(option => {
				if(option.title == 'cutting type'){
					hasCuttingType = true;
				}
			});
		} else {
			hasCuttingType = true;
		}

		if(hasCuttingType){
			this.reAddToCartHelper(item);
		}
		else {
			/**
			 * we have to open a modal to select cutting type
			 */
			this.openPaymentModalCuttingType(item);
		}
	}

	reAddToCartHelper(item:any, custom_options: any = null) {
		this.cartService.setLoader(true);
		this.cartService.reAddToCart(item, custom_options).then((reAdd) => {
			this.cartService.toastService.add(this.lang.getLang("l104a"));
			this.cartService.setLoader(false);
			this.cartService.getCart();
		});
	}

	openPaymentModalCuttingType(item:any) {
		let config: ModalOptions = {
			backdrop: "static",
			keyboard: false,
			animated: true,
			ignoreBackdropClick: true,
			initialState: {
				item: item,
			},
		};
	
		this.modalRef = this.modalService.show(CuttingTypeComponent, config);
		this.modalRef.setClass("cutting-type-option artwork-modal modal-dialog-centered");
		this.modalRef.content.onClose = (data) => {
			if(data){
				this.reAddToCartHelper(item, data);
			}
		  	this.modalRef.hide();
		};
	}
}
